/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePowermembershipDto } from '../models/work-create-powermembership-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkPowermembership } from '../models/work-powermembership';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdatePowermembershipDto } from '../models/work-update-powermembership-dto';

@Injectable({ providedIn: 'root' })
export class WorkPowermembershipsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `powermembershipsV2ControllerFindAllPaginated()` */
  static readonly PowermembershipsV2ControllerFindAllPaginatedPath = '/v2/powermemberships/paginated';

  /**
   * Required permissions: powermemberships:read, powermemberships:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `powermembershipsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  powermembershipsV2ControllerFindAllPaginated$Response(
    params?: {
      withSupplier?: boolean;
      onlyValids?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Filter by locationId query param.
     *           <p>
     *              <b>Format: </b> filter.locationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.locationId=$not:$like:John Doe&filter.locationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.locationId'?: Array<string>;

    /**
     * Filter by supplierId query param.
     *           <p>
     *              <b>Format: </b> filter.supplierId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supplierId=$not:$like:John Doe&filter.supplierId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supplierId'?: Array<string>;

    /**
     * Filter by supplier.name query param.
     *           <p>
     *              <b>Format: </b> filter.supplier.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supplier.name=$not:$like:John Doe&filter.supplier.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supplier.name'?: Array<string>;

    /**
     * Filter by location.name query param.
     *           <p>
     *              <b>Format: </b> filter.location.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.location.name=$not:$like:John Doe&filter.location.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.location.name'?: Array<string>;

    /**
     * Filter by validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validFrom=$not:$like:John Doe&filter.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validFrom'?: Array<string>;

    /**
     * Filter by validTo query param.
     *           <p>
     *              <b>Format: </b> filter.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validTo=$not:$like:John Doe&filter.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validTo'?: Array<string>;

    /**
     * Filter by totalIncl query param.
     *           <p>
     *              <b>Format: </b> filter.totalIncl={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.totalIncl=$not:$like:John Doe&filter.totalIncl=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.totalIncl'?: Array<string>;

    /**
     * Filter by returnHighRate query param.
     *           <p>
     *              <b>Format: </b> filter.returnHighRate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.returnHighRate=$not:$like:John Doe&filter.returnHighRate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.returnHighRate'?: Array<string>;

    /**
     * Filter by returnLowRate query param.
     *           <p>
     *              <b>Format: </b> filter.returnLowRate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.returnLowRate=$not:$like:John Doe&filter.returnLowRate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.returnLowRate'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> location.name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>locationId</li>
     * <li>supplierId</li>
     * <li>totalIncl</li>
     * <li>returnHighRate</li>
     * <li>returnLowRate</li>
     * <li>validFrom</li>
     * <li>validTo</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'locationId:ASC' | 'locationId:DESC' | 'supplierId:ASC' | 'supplierId:DESC' | 'totalIncl:ASC' | 'totalIncl:DESC' | 'returnHighRate:ASC' | 'returnHighRate:DESC' | 'returnLowRate:ASC' | 'returnLowRate:DESC' | 'validFrom:ASC' | 'validFrom:DESC' | 'validTo:ASC' | 'validTo:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> location.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>location.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkPowermembership>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'supplierId'?: (string | Array<string>);
'supplier.name'?: (string | Array<string>);
'location.name'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'totalIncl'?: (string | Array<string>);
'returnHighRate'?: (string | Array<string>);
'returnLowRate'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPowermembershipsV2Service.PowermembershipsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withSupplier', params.withSupplier, {});
      rb.query('onlyValids', params.onlyValids, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.id', params['filter.id'], {});
      rb.query('filter.locationId', params['filter.locationId'], {});
      rb.query('filter.supplierId', params['filter.supplierId'], {});
      rb.query('filter.supplier.name', params['filter.supplier.name'], {});
      rb.query('filter.location.name', params['filter.location.name'], {});
      rb.query('filter.validFrom', params['filter.validFrom'], {});
      rb.query('filter.validTo', params['filter.validTo'], {});
      rb.query('filter.totalIncl', params['filter.totalIncl'], {});
      rb.query('filter.returnHighRate', params['filter.returnHighRate'], {});
      rb.query('filter.returnLowRate', params['filter.returnLowRate'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkPowermembership>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'id'?: (string | Array<string>);
        'locationId'?: (string | Array<string>);
        'supplierId'?: (string | Array<string>);
        'supplier.name'?: (string | Array<string>);
        'location.name'?: (string | Array<string>);
        'validFrom'?: (string | Array<string>);
        'validTo'?: (string | Array<string>);
        'totalIncl'?: (string | Array<string>);
        'returnHighRate'?: (string | Array<string>);
        'returnLowRate'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: powermemberships:read, powermemberships:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `powermembershipsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  powermembershipsV2ControllerFindAllPaginated(
    params?: {
      withSupplier?: boolean;
      onlyValids?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Filter by locationId query param.
     *           <p>
     *              <b>Format: </b> filter.locationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.locationId=$not:$like:John Doe&filter.locationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.locationId'?: Array<string>;

    /**
     * Filter by supplierId query param.
     *           <p>
     *              <b>Format: </b> filter.supplierId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supplierId=$not:$like:John Doe&filter.supplierId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supplierId'?: Array<string>;

    /**
     * Filter by supplier.name query param.
     *           <p>
     *              <b>Format: </b> filter.supplier.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.supplier.name=$not:$like:John Doe&filter.supplier.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.supplier.name'?: Array<string>;

    /**
     * Filter by location.name query param.
     *           <p>
     *              <b>Format: </b> filter.location.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.location.name=$not:$like:John Doe&filter.location.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.location.name'?: Array<string>;

    /**
     * Filter by validFrom query param.
     *           <p>
     *              <b>Format: </b> filter.validFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validFrom=$not:$like:John Doe&filter.validFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validFrom'?: Array<string>;

    /**
     * Filter by validTo query param.
     *           <p>
     *              <b>Format: </b> filter.validTo={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.validTo=$not:$like:John Doe&filter.validTo=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.validTo'?: Array<string>;

    /**
     * Filter by totalIncl query param.
     *           <p>
     *              <b>Format: </b> filter.totalIncl={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.totalIncl=$not:$like:John Doe&filter.totalIncl=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.totalIncl'?: Array<string>;

    /**
     * Filter by returnHighRate query param.
     *           <p>
     *              <b>Format: </b> filter.returnHighRate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.returnHighRate=$not:$like:John Doe&filter.returnHighRate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.returnHighRate'?: Array<string>;

    /**
     * Filter by returnLowRate query param.
     *           <p>
     *              <b>Format: </b> filter.returnLowRate={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.returnLowRate=$not:$like:John Doe&filter.returnLowRate=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.returnLowRate'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> location.name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>locationId</li>
     * <li>supplierId</li>
     * <li>totalIncl</li>
     * <li>returnHighRate</li>
     * <li>returnLowRate</li>
     * <li>validFrom</li>
     * <li>validTo</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'locationId:ASC' | 'locationId:DESC' | 'supplierId:ASC' | 'supplierId:DESC' | 'totalIncl:ASC' | 'totalIncl:DESC' | 'returnHighRate:ASC' | 'returnHighRate:DESC' | 'returnLowRate:ASC' | 'returnLowRate:DESC' | 'validFrom:ASC' | 'validFrom:DESC' | 'validTo:ASC' | 'validTo:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> location.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>location.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkPowermembership>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'supplierId'?: (string | Array<string>);
'supplier.name'?: (string | Array<string>);
'location.name'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'totalIncl'?: (string | Array<string>);
'returnHighRate'?: (string | Array<string>);
'returnLowRate'?: (string | Array<string>);
};
};
}> {
    return this.powermembershipsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkPowermembership>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'supplierId'?: (string | Array<string>);
'supplier.name'?: (string | Array<string>);
'location.name'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'totalIncl'?: (string | Array<string>);
'returnHighRate'?: (string | Array<string>);
'returnLowRate'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkPowermembership>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'supplierId'?: (string | Array<string>);
'supplier.name'?: (string | Array<string>);
'location.name'?: (string | Array<string>);
'validFrom'?: (string | Array<string>);
'validTo'?: (string | Array<string>);
'totalIncl'?: (string | Array<string>);
'returnHighRate'?: (string | Array<string>);
'returnLowRate'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `powermembershipsV2ControllerUnlinkFromSupplier()` */
  static readonly PowermembershipsV2ControllerUnlinkFromSupplierPath = '/v2/powermemberships/unlink-from-supplier/{id}';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `powermembershipsV2ControllerUnlinkFromSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  powermembershipsV2ControllerUnlinkFromSupplier$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPowermembershipsV2Service.PowermembershipsV2ControllerUnlinkFromSupplierPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `powermembershipsV2ControllerUnlinkFromSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  powermembershipsV2ControllerUnlinkFromSupplier(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.powermembershipsV2ControllerUnlinkFromSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `powermembershipsV2ControllerUpdate()` */
  static readonly PowermembershipsV2ControllerUpdatePath = '/v2/powermemberships/{id}';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `powermembershipsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  powermembershipsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdatePowermembershipDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPowermembership>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPowermembershipsV2Service.PowermembershipsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPowermembership>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `powermembershipsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  powermembershipsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdatePowermembershipDto
    },
    context?: HttpContext
  ): Observable<WorkPowermembership> {
    return this.powermembershipsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPowermembership>): WorkPowermembership => r.body)
    );
  }

  /** Path part for operation `powermembershipsV2ControllerCreate()` */
  static readonly PowermembershipsV2ControllerCreatePath = '/v2/powermemberships';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `powermembershipsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  powermembershipsV2ControllerCreate$Response(
    params: {
      body: WorkCreatePowermembershipDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPowermembership>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPowermembershipsV2Service.PowermembershipsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPowermembership>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `powermembershipsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  powermembershipsV2ControllerCreate(
    params: {
      body: WorkCreatePowermembershipDto
    },
    context?: HttpContext
  ): Observable<WorkPowermembership> {
    return this.powermembershipsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPowermembership>): WorkPowermembership => r.body)
    );
  }

}
